import {ActivatedRoute, Router} from "@angular/router";
import {ResultatsCatalogueComponent} from "./resultats/resultats-catalogue.component";
import {ArianeElement, ArianeStore, FilterObject, WindowService, UserStore, CorrespondantStore} from "@digicerba/common";
import {Component, ViewChild} from "@angular/core";
import {RechercheExamenDto, RechercheWithHighlightDto} from "app/common/resources/resources";
import * as lodash from 'lodash';
@Component({
  selector: 'catalogue-examens',
  templateUrl: './catalogue-examens.component.html',
  host: { 'class': 'page' }
})
export class CatalogueExamensComponent {

  nbAlerts: number = 0;
  rechercheExamenDto: RechercheExamenDto;
  termsToHighlight: string;

  @ViewChild(ResultatsCatalogueComponent) resultats: ResultatsCatalogueComponent;

  constructor(private activatedRoute: ActivatedRoute, arianeStore: ArianeStore, private windowService: WindowService,
              private router: Router,
              private userStore: UserStore,
              private correspondantStore: CorrespondantStore) {

    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANE.HOME",
        route: "/accueil"
      },
      {
        libelle: "ARIANE.CATALOGUE",
        route: "/"
      }
    ]
    arianeStore.updateElements(arianeElements);
    this.nbAlerts = this.activatedRoute.snapshot.data['nbAlerts'];
  }

  onFiltering(rechercheWithHighlightDto: RechercheWithHighlightDto) {
    this.rechercheExamenDto = rechercheWithHighlightDto.rechercheExamenDto;
    this.termsToHighlight = lodash.deburr(rechercheWithHighlightDto.termsToHighlight);
  }

  print() {
    this.windowService.openPrint();
  }

  launchPrint() {
    this.resultats.launchPrint();
  }

  detailOpen() {
    return this.resultats.detailOpen;
  }

  exportCsv() {
    this.resultats.exportCsv();
  }

  nbResultats() {
    return this.resultats.titre_resultats;
  }

  goHistorique() {
    this.router.navigate(['/cerba/historique-modifications']);
  }

  isGuest(): boolean {
    let role = this.userStore.getUser().role;
    return role == "INVITE";
  }

  isFr(): boolean {
    return this.correspondantStore.hasTag("fr") && !this.correspondantStore.hasTag("en") && !this.correspondantStore.hasTag("fra");
  }

  checkIFrame() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  /**
   * Check les tags du correspondant en cours pour savoir si on a
   * accès à la partie modification du catalgue examen
   *
   * @returns {boolean} true si le tag pour avoir accès est présent
   * ============================================================== */
  isAuthToCatalogUpdate(): boolean {
    return this.correspondantStore.hasTag("majcatalogue");
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/catalogue-examens/catalogue-examens.component.ts